import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TabItemModel} from '../../models/tab-item-model';


@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, OnChanges {
  @Input() public tabs: TabItemModel[] = [];
  @Input() public addSpaceForScrollbar = true;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}
